import { CardDetailsData } from "@/features/cards/types/CardDetails.type";
import Box from "@/common/components/Box";
import CardDetailCompanyInformation from "../CardDetailCompanyInformation";
import CardDetailFieldPair from "../CardDetailFieldPair";
import type { CompanyData } from "@/features/companies/types/companies.type";
import { ClientCompanyBranchData } from "@/common/types/client/companyBranch.type";

type PersonalCardDetailsProps = {
  cardDetails: CardDetailsData
  companyData: CompanyData
  clientBranch?: ClientCompanyBranchData
}

const PersonalCardDetails = ({ cardDetails, companyData, clientBranch }: PersonalCardDetailsProps) => {
  return (
    <div className="flex flex-col gap-4">
      <CardDetailCompanyInformation
        companyData={companyData}
        companyBranch={cardDetails?.owner?.branch}
      />

      <Box className="flex flex-col items-start rounded-lg gap-2 p-6 py-5">
        {!!clientBranch && (
          <CardDetailFieldPair
            label="Filial"
            value={clientBranch?.display_name || '--'}
          />
        )}

        <div className="flex gap-4 items-center">
          <p className="font-light italic">
            Nome do Dono:
          </p>

          <p className="text-lg uppercase">
            {cardDetails?.owner?.full_name}
          </p>
        </div>
      </Box>
    </div>
  )
}

export default PersonalCardDetails;
